import i18n from '@/utils/i18n';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { TextInput, View } from 'react-native';

const MIN_DIALOG_WIDTH = 400;

interface NameQuoteModalContentProps {
  onChange: (value: string) => void;
  value: string;
}

export const NameQuoteModalContent: React.FC<NameQuoteModalContentProps> = ({
  onChange,
  value,
}) => {
  const [styles, theme] = useStyles();

  return (
    <View style={styles.container}>
      <TextInput
        accessibilityLabel={i18n.t('sales_portal.price_quotes.quote_name')}
        autoFocus
        onChangeText={onChange}
        placeholderTextColor={theme.sk.color.text.tertiary}
        style={styles.input}
        value={value}
      />
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  container: {
    minWidth: MIN_DIALOG_WIDTH,
  },
  input: {
    borderColor: theme.sk.color.border.primary,
    borderRadius: theme.sk.radii.radiusMedium,
    borderWidth: 1,
    color: theme.sk.color.text.primary,
    fontFamily: theme.sk.typography.paragraph.md.fontFamily,
    fontSize: theme.sk.typography.paragraph.md.fontSize,
    paddingHorizontal: theme.sk.spacing.spaceMedium,
    paddingVertical: theme.sk.spacing.spaceSmall,
  },
}));
